import React from 'react';
import Modal from '../ui/Modal';
import './SamplingRecordDetailModal.css';

const SAMPLE_TYPE_LABELS = {
  suprafete: 'Suprafețe',
  personal_medical: 'Personal medical',
  sterilitate: 'Sterilitate',
  aer: 'Aer',
  apa: 'Apă'
};

const TEST_METHOD_LABELS = {
  cultura: 'Cultură',
  amf: 'AMF',
  citologie: 'Citologie',
  other: 'Altele'
};

const INTERP_LABELS = {
  conform: 'Conform',
  neconform: 'Neconform',
  echivoc: 'Echivoc',
  na: 'N/A',
  in_lucru: 'În lucru'
};

const LAB_STATUS_LABELS = {
  pending: 'În așteptare',
  result_received: 'Rezultat primit',
  in_lucru: 'În lucru'
};

const InterpretationBadge = ({ value }) => {
  const label = INTERP_LABELS[value] || value || '—';
  const colors = {
    conform: { bg: '#f0fdf4', color: '#166534' },
    neconform: { bg: '#fef2f2', color: '#991b1b' },
    echivoc: { bg: '#fffbeb', color: '#92400e' },
    na: { bg: '#f9fafb', color: '#6b7280' },
    in_lucru: { bg: '#eff6ff', color: '#1e40af' },
    result_received: { bg: '#f0fdf4', color: '#166534' },
    pending: { bg: '#eff6ff', color: '#1e40af' }
  };
  const c = colors[value] || colors.na;
  return (
    <span className="sampling-detail-badge" style={{ background: c.bg, color: c.color }}>
      {label}
    </span>
  );
};

const Row = ({ label, children }) => (
  <div className="sampling-detail-row">
    <span className="sampling-detail-label">{label}</span>
    <span className="sampling-detail-value">{children}</span>
  </div>
);

/**
 * Detalii înregistrare ATP sau cerere lab — același tip de „card” restrâns ca formularele.
 */
const SamplingRecordDetailModal = ({
  type,
  record,
  isOpen,
  onClose,
  formatDate,
  canRecordLabResult = false,
  onRecordLabResult
}) => {
  if (!isOpen || !record) return null;

  const title =
    type === 'atp'
      ? `Test ATP #${record.atp_id}`
      : `Cerere laborator #${record.request_id}`;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="small">
      {type === 'atp' && (
        <div className="sampling-detail-body">
          <Row label="Departament">{record.department_name || '—'}</Row>
          <Row label="Salon / cameră">{record.room_name || '—'}</Row>
          <Row label="Suprafață">{record.surface_type_name || '—'}</Row>
          <Row label="Operator">{record.operator_name || '—'}</Row>
          <Row label="Valoare ATP (RLU)">
            {record.value !== null && record.value !== undefined && record.value !== ''
              ? `${record.value} RLU`
              : '—'}
          </Row>
          <Row label="Descriere / observații">
            {record.description?.trim() ? (
              <span className="sampling-detail-multiline">{record.description}</span>
            ) : (
              '—'
            )}
          </Row>
          <Row label="Interpretare">
            <InterpretationBadge value={record.interpretation} />
          </Row>
          <Row label="Data înregistrării">{formatDate(record.created_at)}</Row>
        </div>
      )}

      {type === 'lab' && (
        <div className="sampling-detail-body">
          <Row label="Departament">{record.department_name || '—'}</Row>
          <Row label="Salon / cameră">{record.room_name || '—'}</Row>
          <Row label="Suprafață">{record.surface_type_name || '—'}</Row>
          <Row label="Tip probă">
            {SAMPLE_TYPE_LABELS[record.sample_type] || record.sample_type || '—'}
          </Row>
          <Row label="Metodă">
            {TEST_METHOD_LABELS[record.test_method] || record.test_method || '—'}
          </Row>
          {record.test_method === 'other' && (
            <Row label="Specificație metodă">
              {record.test_method_description?.trim() ? (
                <span className="sampling-detail-multiline">{record.test_method_description}</span>
              ) : (
                '—'
              )}
            </Row>
          )}
          <Row label="Operator">{record.operator_name || '—'}</Row>
          <Row label="Stare">{LAB_STATUS_LABELS[record.status] || record.status || '—'}</Row>
          <Row label="Data cererii">{formatDate(record.requested_at)}</Row>

          {record.status === 'result_received' && (
            <div className="sampling-detail-section">
              <div className="sampling-detail-section-title">Rezultat</div>
              <Row label="Valoare / rezultat">
                {record.result_value?.trim() ? (
                  <span className="sampling-detail-multiline">{record.result_value}</span>
                ) : (
                  '—'
                )}
              </Row>
              <Row label="Interpretare rezultat">
                {record.result_interpretation ? (
                  <InterpretationBadge value={record.result_interpretation} />
                ) : (
                  '—'
                )}
              </Row>
              <Row label="Note">
                {record.result_notes?.trim() ? (
                  <span className="sampling-detail-multiline">{record.result_notes}</span>
                ) : (
                  '—'
                )}
              </Row>
              <Row label="Data rezultatului">{formatDate(record.result_recorded_at)}</Row>
            </div>
          )}
        </div>
      )}

      <div className="sampling-detail-actions">
        {type === 'lab' && canRecordLabResult && (
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={() => {
              if (onRecordLabResult) onRecordLabResult();
            }}
          >
            Înregistrează rezultat
          </button>
        )}
        <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>
          Închide
        </button>
      </div>
    </Modal>
  );
};

export default SamplingRecordDetailModal;
